import MeasureAnswersObjectTemplate from "./MeasureAnswersObjectTemplate";

export default MeasureAnswersObjectTemplate;